import { globalCss, mediaQueryMap } from "@leagueplatform/genesis-core";

export const activityViewerOverrides = globalCss({
  ".health-activity-layout.health-activity-layout": {
    backgroundColor: "$surfaceBackgroundPrimary",
  },
  ".health-activity-close.health-activity-close, .health-activity-remove.health-activity-remove":
    {
      insetBlockStart: "$half",
    },
  [`@media ${mediaQueryMap.mobile}`]: {
    ".health-activity-footer.health-activity-footer > [role='progressbar'] + div":
      {
        display: "none",
      },
    ".health-activity-content-wrapper.health-activity-content-wrapper": {
      marginTop: "3rem",
    },
    ".health-activity-remove.health-activity-remove": {
      insetInlineStart: "$none",
    },
    ".health-activity-close.health-activity-close": {
      insetInlineEnd: "$none",
    },
  },
});
